import React, { Component, useState, useEffect } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import Popover from "@material-ui/core/Popover";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import { contentClient } from "../../AxiosClient";
import Pagination from "@material-ui/lab/Pagination";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const useStyles = makeStyles((theme) => ({
  line: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  data: {
    color: theme.palette.text.primary,
  },
}));
function TemplateInfo(props) {
  const [selected, setSelected] = useState(0);
  const [events, setEvents] = useState([]);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [count, setCount] = useState(0);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    getReusableSectionEvents();
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelected(0);
    setPage(0);
  };
  const getReusableSectionEvents = () => {
    contentClient
      .get(`template/${props.template.id}/events`, {
        params: {
          size: 10,
          page: page,
        },
      })
      .then((res) => {
        setEvents(res.data.content);
        setRowsPerPage(res.data.size);
        setCount(res.data.totalPages);
      });
  };
  useEffect(() => {
    getReusableSectionEvents();
  }, []);
  return (
    <>
      <IconButton
        onClick={handleClick}
        color="default"
        aria-label="Template information"
      >
        <InfoIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
      >
        <CardContent>
          <Tabs
            value={selected}
            onChange={(event, index) => {
              setSelected(index);
            }}
            variant="fullWidth"
          >
            <Tab label="Template" />
            <Tab label="Events" />
          </Tabs>
          <SwipeableViews
            index={selected}
            style={{ height: "100%" }}
            containerStyle={{ marginTop: 8 }}
          >
            {selected === 0 && (
              <Typography variant="body2" color="textSecondary" component="p">
                <div className={classes.line}>
                  Id: <span className={classes.data}>{props.template.id}</span>
                </div>
                <div className={classes.line}>
                  Description:{" "}
                  <span className={classes.data}>
                    {props.template.description}
                  </span>
                </div>
                <div className={classes.line}>
                  Author:{" "}
                  <span className={classes.data}>
                    {props.template.author.userLogin}
                  </span>
                </div>
                <div className={classes.line}>
                  Created on:{" "}
                  <span className={classes.data}>
                    {moment(props.template.createdDate).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </span>
                </div>
              </Typography>
            )}
            {selected === 1 && (
              <div>
                {events.map((event) => (
                  <ListItem>
                    {event.type === "edit" && (
                      <>
                        <ListItemIcon>
                          <Tooltip title={"Edited"} aria-label={"Edited"}>
                            <EditIcon aria-label="Template event" />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText
                          primary={moment(event.date).format("LLLL")}
                          secondary={event.user.userLogin}
                        />
                      </>
                    )}
                    {event.type === "used" && (
                      <>
                        <ListItemIcon>
                          <Tooltip title={"Used"} aria-label={"Used"}>
                            <FileCopyIcon />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText
                          primary={moment(event.date).format("LLLL")}
                          secondary={"Used to create a Knowledge Item"}
                        />
                      </>
                    )}
                  </ListItem>
                ))}
                {count > 10 && (
                  <Pagination
                    style={{ margin: 8, alignSelf: "center" }}
                    count={count}
                    rowsPerPage={rowsPerPage}
                    onChange={(e, page) => setPage(page - 1)}
                    color="primary"
                  />
                )}
              </div>
            )}
          </SwipeableViews>
        </CardContent>
      </Popover>
    </>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withRouter(withTheme(TemplateInfo)));
